import { Link as Scroll } from 'react-scroll'
import styled, { css } from 'styled-components'

import { theme } from '@/styles/theme'

type IndexProps = {
  links: {
    name: string
    anchor: string
  }[][]
  listType: 'number' | 'disc' | 'roman' | 'article'
  columnGap: number
}

export const Index = ({ links, listType, columnGap }: IndexProps) => {
  // ナンバリングのスタート値を計算する
  const setStartValue = (index: number) => {
    let count = 0

    if (index === 0) return count
    ;[...Array(index)].map((_, i) => (count += links[i].length))

    return count
  }

  return (
    <Wrapper columnGap={columnGap}>
      {links.map((arr, index) => (
        <List
          key={`${arr.toString()}${index}`}
          startValue={setStartValue(index)}
          listType={listType}
          as={listType === 'disc' ? 'ul' : ''}
        >
          {arr.map(({ name, anchor }) => (
            <li key={name} data-list-type={listType}>
              <Scroll to={anchor} smooth={true} offset={-105}>
                {name}
              </Scroll>
            </li>
          ))}
        </List>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ columnGap: number }>`
  border: 1px solid #707070;
  padding: 30px 25px 25px;
  display: flex;
  column-gap: ${({ columnGap }) => columnGap}px;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    padding: 30px 20px 27px;
  }
`

const ListStyle = css`
  color: ${theme.colors.trialBlue};
  counter-increment: number;
`

const List = styled.ol<{ listType: string; startValue: number }>`
  letter-spacing: 0.32px;
  counter-reset: ${({ startValue, listType }) =>
    listType !== 'disc' ? `number ${startValue}` : ''};

  li {
    line-height: 26px;
    letter-spacing: 0.3px;

    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }

    &[data-list-type='number']::before {
      ${ListStyle};

      content: counter(number) '. ';
    }

    &[data-list-type='roman']::before {
      ${ListStyle};

      content: counter(number, upper-roman) '. ';
    }

    &[data-list-type='article']::before {
      ${ListStyle};

      content: '' counter(number) '.';
    }

    &[data-list-type='disc']::before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: ${theme.colors.trialBlue};
      display: inline-block;
      margin-right: 0.5em;
      transform: translateY(-50%);
    }
  }

  a {
    color: ${theme.colors.trialBlue};
  }

  @media screen and (max-width: 1047px) {
    li {
      font-size: 15px;
    }
  }
`
